/**
 * Human wording for the inactivity window shown in the countdown dialog.
 *
 * The window is configured in minutes (`environment.idleTimeoutMinutes`) so it
 * stays a single number to keep in sync with the backend
 * `session_idle_timeout`, but printing it raw stops reading like a sentence as
 * soon as it goes past an hour: the window is 2 h, and "You have been inactive
 * for 120 minutes" reads like a bug rather than a policy.
 *
 * @param minutes Length of the inactivity window, in minutes.
 * @returns e.g. "2 hours", "1 hour 30 minutes", "30 minutes".
 */
export function formatIdleWindowLabel(minutes: number): string {
  const total = Number.isFinite(minutes) ? Math.max(1, Math.round(minutes)) : 1;
  const hours = Math.floor(total / 60);
  const remainingMinutes = total % 60;

  const parts: string[] = [];
  if (hours > 0) {
    parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
  }
  if (remainingMinutes > 0 || hours === 0) {
    parts.push(`${remainingMinutes} ${remainingMinutes === 1 ? 'minute' : 'minutes'}`);
  }

  return parts.join(' ');
}
